import { Theme, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Route from 'routes/Routes';
import {ApplicationFilled, BookmarkFilled, ContactsFilled, MailFilled, CalendarFilled, SettingsFilled, DocumentFilled} from 'components/icons';
import AdminCategory, { AdminCategoryProps } from './AdminCategory';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    flexDirection: 'column',

    [theme.breakpoints.up('md')]: {
      height: 'calc(100vh - 376px - 62px)',
      minHeight: 450,
      padding: '20px 40px',
    },

    [theme.breakpoints.down('md')]: {
      padding: '20px 30px',
    },
  },
}), { name: 'AdminCategories' });

const categoriesProps: AdminCategoryProps[] = [
  {
    descriptionMessageId: 'admin.category.messages.description',
    icon: MailFilled,
    route: Route.ADMIN_MESSAGES,
    titleMessageId: 'admin.menu.messages',
  },
  {
    descriptionMessageId: 'admin.category.bookmarks.description',
    icon: BookmarkFilled,
    route: Route.ADMIN_BOOKMARKS,
    titleMessageId: 'admin.menu.bookmarks',
  },
  {
    descriptionMessageId: 'admin.category.contacts.description',
    icon: ContactsFilled,
    route: Route.ADMIN_CONTACTS,
    titleMessageId: 'admin.menu.contacts',
  },
  {
    descriptionMessageId: 'admin.category.applications.description',
    icon: ApplicationFilled,
    route: Route.ADMIN_APPLICATIONS,
    titleMessageId: 'admin.menu.applications',
  },
  {
    descriptionMessageId: 'admin.category.organizer.description',
    icon: CalendarFilled,
    route: Route.ADMIN_ORGANIZER,
    titleMessageId: 'admin.menu.organizer',
  },
  {
    descriptionMessageId: 'admin.category.workbook.description',
    icon: DocumentFilled,
    route: Route.ADMIN_WORKBOOK,
    titleMessageId: 'admin.menu.workbook',
  },
];

const AdminCategories = (): JSX.Element => {
  const classes = useStyles();

  const categories = categoriesProps.map((categoryProps, index) => (
    <AdminCategory key={index} {...categoryProps} />
  ));

  return (
    <Grid className={classes.container} container spacing={3}>
      {categories}
    </Grid>
  );
};

export default AdminCategories;
